import { ApplicationTrophyDto } from '~/modules/Products/Application/Dtos/ApplicationTrophyDto'
import { ComponentTrophyDto } from '~/modules/Products/Infrastructure/Dtos/ComponentTrophyDto'
import { ComponentProductAnimation } from '~/modules/Products/Infrastructure/Dtos/ComponentProductAnimation'
import { repairTextEncoding } from '~/modules/Shared/Domain/Helpers/String'

export class ComponentTrophyDtoTransformer {
  public static fromApplication (applicationTrophyDto: ApplicationTrophyDto): ComponentTrophyDto {
    let animation: ComponentProductAnimation | null = null

    if (applicationTrophyDto.animation !== null) {
      animation = {
        url: applicationTrophyDto.animation.url,
        type: applicationTrophyDto.animation.type,
      }
    }

    return {
      id: applicationTrophyDto.id,
      type: applicationTrophyDto.type,
      content: {
        header: repairTextEncoding(applicationTrophyDto.content.header),
        title: repairTextEncoding(applicationTrophyDto.content.title),
        subtitle: repairTextEncoding(applicationTrophyDto.content.subtitle),
      },
      description: repairTextEncoding(applicationTrophyDto.description),
      discipline: applicationTrophyDto.discipline === null ? null : repairTextEncoding(applicationTrophyDto.discipline),
      animation: animation,
      memoriesCount: applicationTrophyDto.memoriesCount,
      mintStatus: applicationTrophyDto.mintStatus,
      imageUrl: applicationTrophyDto.imageUrl,
    }
  }
}
